import PaddedSlider from './PaddedSlider';
export default PaddedSlider;
